import type React from 'react';
import { useTheme } from 'styled-components';

import { Icons } from '@/js/libs/ui';

import { ActiveIndicatorWrapper } from './styles';

interface ActiveIndicatorProps {
  isActive?: boolean;
}

export const ActiveIndicator: React.FC<ActiveIndicatorProps> = ({ isActive }) => {
  const theme = useTheme();
  return (
    <ActiveIndicatorWrapper>
      {isActive ? <Icons.Check color={theme.colors.main} /> : <Icons.Close size={12} color={theme.colors.positive70} />}
    </ActiveIndicatorWrapper>
  );
};
